module.exports = __webpack_public_path__ + "img/activities-4.22a15123.jpg";